"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMoveToJobCtrl = void 0;
var i18n_1 = require("../../i18n");
var index_1 = require("../../services/index");
var page_state_1 = require("../../state/page.state");
var collection_move_job_modal_1 = require("../collection.move.modal/collection.move.job.modal");
exports.CollectionMoveToJobCtrl = {
    canMove: function () {
        var userProfile = index_1.Services.UserProfile.get(index_1.Services.User.current.objectId);
        var canUserMove = index_1.Services.UserProfile.isDepartmentAdmin(userProfile) || index_1.Services.UserProfile.isDepartmentDataAdmin(userProfile);
        return canUserMove;
    },
    showMoveModal: function () {
        var collections = page_state_1.CurrentState.Tag.collections;
        var modal = new collection_move_job_modal_1.CollectionMoveToJobModal({
            title: i18n_1.T.COLLECTION_MOVE_JOB_TITLE,
            confirm: i18n_1.T.COLLECTION_MOVE,
            success: {
                key: i18n_1.T.COLLECTION_MOVE_SUCCESS,
                attrs: {
                    count: collections.length
                }
            }
        }, collections);
        modal.open();
    }
};
//# sourceMappingURL=collection.move.job.ctrl.js.map